import React from 'react';
import { Box, Button, CircularProgress, IconButton, Popover, Stack, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import classes from '../docFwb.module.css';

const FwbSaveModal = ({
  open = false,
  anchorEl = null,
  onClose,
  onSave,
  currentVersion = 1,
  currentVersionName = 'Version 1',
  nextVersion = 2,
  isLoading = false,
}) => {
  const handleChooseOverwrite = () => {
    if (onSave) {
      onSave({
        saveType: 'overwrite',
        targetVersion: currentVersion,
        versionName: currentVersionName,
      });
    }
  };

  const handleConfirmNewVersion = () => {
    if (onSave) {
      onSave({
        saveType: 'new_version',
        versionName: `Version ${nextVersion}`,
      });
    }
  };

  return (
    <Popover
      sx={{ zIndex: 1400 }}
      open={Boolean(open && anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      slotProps={{
        paper: {
          className: classes.savePopoverPaper,
          sx: {
            p: 2,
            width: 320,
            maxWidth: '90vw',
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(9, 43, 74, 0.16)',
            border: '1px solid #e2e8f0',
          },
        },
      }}
    >
      <Box sx={{ width: '100%' }}>
        <Stack direction='row' justifyContent='space-between' alignItems='center' mb={1.5}>
          <Typography variant='subtitle2' fontWeight={700} color='var(--primaryblue)' sx={{ fontSize: '13px' }}>
            Save FWB Message
          </Typography>
          <IconButton size='small' onClick={onClose} sx={{
            p: 0.5,
            color: '#94a3b8' 
          }}>
            <Close sx={{ fontSize: 16 }} />
          </IconButton>
        </Stack>

        <Stack direction='column' spacing={1.5}>
          <Typography variant='caption' color='#64748b' sx={{
            fontSize: '11.5px',
            lineHeight: 1.4 
          }}>
            Choose how you would like to save your changes:
          </Typography>

          <Button
            variant='contained'
            color='primary'
            fullWidth
            onClick={handleChooseOverwrite}
            disabled={isLoading}
            sx={{
              textTransform: 'none',
              fontSize: '12px',
              py: 0.8,
              borderRadius: '8px',
              fontWeight: 600,
            }}
          >
            {isLoading ? <CircularProgress size={16} sx={{ color: '#fff' }} /> : `Save to Current Version (${currentVersionName || `Version ${currentVersion}`})`}
          </Button>

          <Button
            variant='outlined'
            color='primary'
            fullWidth
            onClick={handleConfirmNewVersion}
            disabled={isLoading}
            sx={{
              textTransform: 'none',
              fontSize: '12px',
              py: 0.8,
              borderRadius: '8px',
              fontWeight: 600,
            }}
          >
            {isLoading ? <CircularProgress size={16} sx={{ color: 'var(--primaryblue)' }} /> : `Save as Version ${nextVersion}`}
          </Button>
        </Stack>
      </Box>
    </Popover>
  );
};

export default FwbSaveModal;
